import { Handler } from './handler.es6';
import { changeActive } from './changeActive.es6';
import { zoom } from './zoom.es6';
import { appendSolo } from './appendSolo.es6';

export function main() {
    const status = {
        activeIdx: null,
    };
    let value = status['activeIdx'];

    //オブジェクトstatusのプロパティactiveIdxの監視
    Object.defineProperty(status, 'activeIdx', {
        get: () => value,
        set: (newValue) => {
            const oldValue = value;
            value = newValue;
            changeActive(oldValue, value);
        },
    });

    const changeTriggers = document.querySelectorAll('[data-change-trigger]');
    changeTriggers.forEach((trigger) => {
        const instance = new Handler(status, trigger);
    });

    // パラメーターに値がある場合モーダルを開く
    function getParam() {
        const queryString = window.location.search;
        const params = new URLSearchParams(queryString);
        const value = params.get('characterIdx');
        if (!value) return;
        const idx = Number(value);
        if (0 <= idx) {
            setTimeout(() => {
                const modal = document.querySelector('.js-modal[data-modalid="character"]');
                modal.classList.add('-active');
                status.activeIdx = idx;
            }, 600);
        }
    }

    getParam();
    zoom();
    appendSolo();
}
